import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function EXHomeVelki() {
  const navigate = useNavigate();

  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(true);

  // Step 1: Fetch logo first
  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
        if (!response.ok) throw new Error("Failed to fetch logo");
        const data = await response.json();
        setLogo(data[0]?.logo || null);
      } catch (error) {
        console.error("Error fetching logo:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchLogo();
  }, []);

  // Step 2: Call iframe API only after logo loaded
  useEffect(() => {
    if (loading || !logo) return;

    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const remote_id = localStorage.getItem("remote_id");

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/velki/play`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: "eg_" + remote_id,
            token: token,
            providerSitePage: window.location.origin,
            origin: window.location.origin,
            siteLogo: `${process.env.REACT_APP_API_URL}/storage/${logo}`,
          }),
        });

        const dataly = await response.json();
        const iframeUrl = dataly?.data?.launch?.data?.launchUrl;

        if (!iframeUrl) throw new Error("Invalid iframe launch response");

        navigate("/gamerun", { state: { iframeUrl } });
      } catch (error) {
        console.error("Error fetching player login:", error);
      }
    };

    fetchData();
  }, [logo, loading, navigate]);

  return null;
}

export default EXHomeVelki;
